/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionnotfounderror3Inputs */

const en_actionnotfounderror3 = /** @type {(inputs: Actionnotfounderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action no longer exists.`)
};

const de_actionnotfounderror3 = /** @type {(inputs: Actionnotfounderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Aktion gibt es nicht mehr.`)
};

/**
* | output |
* | --- |
* | "This action no longer exists." |
*
* @param {Actionnotfounderror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionnotfounderror3 = /** @type {((inputs?: Actionnotfounderror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionnotfounderror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionnotfounderror3(inputs)
	return de_actionnotfounderror3(inputs)
});
export { actionnotfounderror3 as "actionNotFoundError" }